import { createFileRoute, redirect } from '@tanstack/react-router';

import { currentCohort } from '@/cohort-content';
import { Welcome } from '@/features/registration';

export const Route = createFileRoute('/$hci_shortname/')({
	beforeLoad: async () => {
		if (!currentCohort) {
			throw redirect({
				to: '/oops',
			});
		}
	},
	component: () => <Welcome cohort={currentCohort} />,
	head: () => ({
		meta: [
			{
				title: `Welcome | ${currentCohort.name}`,
			},
		],
	}),
});
